export { default } from "./ListingCardVertical";
